import selectors from '../../globals/selectors';
import classNames from '../../globals/classNames';
import htmlToDom from '../../helpers/htmlToDom';

export default class View {
	#element;

	#selectedOptionEl;

	#optionEls;

	#handleOptionClick;

	static parseOptionsFromEls(optionEls) {
		return [...optionEls].map((el) => ({
			text: el.textContent,
			value: el.dataset.selectOption,
		}));
	}

	static makeOptionEl(text, value) {
		return htmlToDom(
			`<div class="select-option" data-select-option="${value}">${text}</div>`
		);
	}

	constructor(element, needRenderOptions) {
		this.#element = element;
		this.#selectedOptionEl = element.querySelector(selectors.select.selected);
		if (needRenderOptions) {
			this.#optionEls = null;
		} else {
			this.#optionEls = element.querySelectorAll(selectors.select.option);
		}
	}

	toggleOptionsVisibility(isVisible) {
		this.#element.classList.toggle(
			classNames.select.isOptionsVisible,
			isVisible
		);
	}

	render(state) {
		const selectedTextEl = this.#selectedOptionEl.querySelector(
			selectors.select.selectedText
		);
		selectedTextEl.textContent = state.selectedOptionText;
		this.#selectedOptionEl.dataset.selectSelected = state.selected;
	}

	init({ handleSelectedOptionClick, handleBodyClick, handleOptionClick }) {
		this.#selectedOptionEl.addEventListener('click', handleSelectedOptionClick);
		this.#handleOptionClick = handleOptionClick;
		this.#optionEls.forEach((el) =>
			el.addEventListener('click', handleOptionClick)
		);
		document.body.addEventListener('click', handleBodyClick);
	}
}
